import styled from 'styled-components'

import BaseIllustration from 'components/atoms/Illustration'
import * as S from 'components/templates/styled'
import { theme } from 'styles/theme'
import { getSize } from 'utils'

export const Container = styled(S.Container)`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  @media (max-aspect-ratio: 1/1) {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
  }
`

export const TextBlock = styled.div`
  grid-area: text-block;
  max-height: ${getSize(750)};
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${getSize(11)};

  p {
    margin: 0;
  }

  @media (max-aspect-ratio: 1/1) {
    -webkit-line-clamp: 10;
  }
`

export const Decoration = styled.div`
  width: ${getSize(27)};
  height: ${getSize(6)};
  background-color: ${theme.colors.limeGreen};
  margin-bottom: ${getSize(14)};
`
export const Illustration = styled(BaseIllustration)`
  grid-area: illustration;
  position: initial;
  height: 100%;
  width: 100%;
  overflow: hidden;
`
